import { useState, useEffect } from "react";

const Hero = ({ data }) => {
    return (
        <div
            data-nosnippet
            id="hero"
            className="relative min-h-[95vh] overflow-hidden"
            style={{
                background:
                    "linear-gradient(90deg, rgb(0, 222, 161) 0%, rgb(0, 222, 161) 10%, #3fb2dd 30%, hsl(220, 97.3%, 55.9%) 100%)",
            }}
        >
            {/* 彩色光圈背景 */}
            <div className="absolute top-10 left-1/4 w-[400px] h-[400px] bg-cyan-400 opacity-30 rounded-full blur-[180px] z-0"></div>
            <div className="absolute bottom-10 right-1/4 w-[300px] h-[300px] bg-blue-500 opacity-20 rounded-full blur-[160px] z-0"></div>

            <section className="relative z-10">
                <div
                    className="z-10 flex flex-col md:flex-row gap-12 items-center w-full px-4 sm:px-6 md:px-8 md:max-w-[1440px] lg:w-[70%] mx-auto mt-16"
                    style={{
                        paddingTop: "6rem",
                        paddingBottom: "3rem",
                    }}
                >
                    {/* 左侧内容 */}
                    <div className="flex-1 max-w-3xl text-left">
                        <h2 className="mb-8 text-4xl sm:text-5xl md:text-6xl font-bold text-white drop-shadow-md leading-tight md:leading-snug text-balance">
                            {data.title}
                        </h2>
                        <p className="mb-10 text-base sm:text-lg xl:text-2xl text-gray-100 drop-shadow-sm leading-relaxed md:leading-loose">
                            {data.subTitle}
                        </p>

                        {/* 按钮 */}
                        <div className="flex flex-col sm:flex-row gap-4 pt-4">
                            <a
                                href={data.buttonLink}
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center justify-center rounded-md px-6 py-4 text-white font-medium bg-blue-500 hover:bg-blue-600 transition"
                            >
                                {data.buttonTitle}
                            </a>
                            <a
                                href={data.button2Link}
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center justify-center rounded-md px-6 py-4 text-blue-500 font-medium bg-white hover:bg-gray-100 transition"
                            >
                                {data.button2Title}
                            </a>
                            <a
                                href={data.button3Link}
                                target="_blank"
                                rel="noreferrer"
                                className="flex items-center justify-center rounded-md px-6 py-4 text-blue-500 font-medium bg-white hover:bg-gray-100 transition"
                            >
                                {data.button3Title}
                            </a>
                        </div>
                    </div>

                    {/* 右侧图像 */}
                    <div className="flex-shrink-0 w-[200px] sm:w-[280px] md:w-[400px] lg:w-[500px] max-w-full flex justify-center md:justify-end items-center mt-2 md:mt-0 relative">
                        <img
                            src="/banner.png"
                            alt="banner"
                            className="w-full h-auto object-contain max-h-[40vh] sm:max-h-[55vh] md:max-h-[65vh] lg:max-h-[70vh]"
                        />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Hero;
